var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5415 5.62488C10.5415 5.21066 10.2057 4.87488 9.7915 4.87488C9.37729 4.87488 9.0415 5.21066 9.0415 5.62488V10.6249C9.0415 11.0391 9.37729 11.3749 9.7915 11.3749H13.1248C13.5391 11.3749 13.8748 11.0391 13.8748 10.6249C13.8748 10.2107 13.5391 9.87488 13.1248 9.87488H10.5415V5.62488Z",
    fill: "#505050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 1.5415C5.32843 1.5415 1.5415 5.32843 1.5415 9.99984C1.5415 14.6712 5.32843 18.4582 9.99984 18.4582C14.6712 18.4582 18.4582 14.6712 18.4582 9.99984C18.4582 5.32843 14.6712 1.5415 9.99984 1.5415ZM3.0415 9.99984C3.0415 6.15686 6.15686 3.0415 9.99984 3.0415C13.8428 3.0415 16.9582 6.15686 16.9582 9.99984C16.9582 13.8428 13.8428 16.9582 9.99984 16.9582C6.15686 16.9582 3.0415 13.8428 3.0415 9.99984Z",
    fill: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.b2bc00090ce2eff3170bc1b1b1a79f7c.svg";
export { ForwardRef as ReactComponent };